import React from 'react'
import PropTypes from 'prop-types'

import { StyledFeaturesList } from 'components/product/featuresSection/styled';

function ProductFeaturesSection({ listItems }) {
  return (
    <StyledFeaturesList>
      {listItems.map(el => {
            const icon = el.icon.url;
            const mainFeatureText = el.feature_text;

            return (
              <li>
                <img src={icon} />
                <span>{mainFeatureText}</span>
              </li>
            )
          })}
    </StyledFeaturesList>
  )
}

ProductFeaturesSection.propTypes = {
  listItems: PropTypes.array
}

export default ProductFeaturesSection

